import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createCompanyApiToken,
  getCompanyApiTokens,
  revokeCompanyApiToken,
} from "services/companyApiToken";

const TOKEN_KEY = ["company-api-tokens"];

export const useCompanyApiTokens = () =>
  useQuery({
    queryKey: TOKEN_KEY,
    queryFn: getCompanyApiTokens,
  });

export const useCreateCompanyApiToken = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCompanyApiToken,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TOKEN_KEY }),
  });
};

export const useRevokeCompanyApiToken = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: revokeCompanyApiToken,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TOKEN_KEY }),
  });
};
